export default __webpack_public_path__ + "static/media/donuts-no-3.317cd796.ogg";